module.exports = __webpack_public_path__ + "img/userWoman.c94516f6.svg";